export default "__VITE_ASSET__yzdWyX4E__"